import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-16 md:py-24 bg-background-100/60">
      <div className="container-custom">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-primary-600 uppercase tracking-widest mb-3">
            {t("home:shopByCategory", "Shop by Category")}
          </p>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-900 leading-none">
            <span className="font-normal italic font-caveat text-primary-500">
              {t("home:browseAll", "Browse All")}
            </span>
            <br />
            <span className="font-heading">{t("home:categoriesSub", "Categories")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`relative ${cat.color} aspect-[4/5] flex items-center justify-center overflow-hidden`}>
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 bg-background-50">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                  {cat.name}
                </h3>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm text-primary-600 font-medium whitespace-nowrap">
                  Browse <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}